import * as React from 'react';
import { flow } from 'lodash';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import { reduxForm, formValueSelector } from 'redux-form';
import { IAuthState } from '../../../../services/auth/models';
import ForgottenPasswordForm from './components/ForgottenPasswordForm';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';

interface IForgottenPasswordProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push: (route: string) => void;
  };
}

class ForgottenPassword extends React.Component<IForgottenPasswordProps> {
  private handleSubmit = (values) => {
    const { actions } = this.props;
    actions.auth.forgottenPassword(values.email);
  }

  public render() {
    const { auth } = this.props;

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h1>Forgot your password</h1>
          {!auth.resetPassword && (
            <h4>Please complete the following information to reset your password</h4>
          )}
        </div>
        {!auth.resetPassword ? (
          <ForgottenPasswordForm onSubmit={this.handleSubmit}/>
        ) : (
          <div className="blue-section">
            <p>
              An email has been sent to you to reset your password.
              If this email did not reach you in the next 5 minutes, we invite you
              to check your "junk mail" folder.
            </p>
            <p>
              <u>Important</u> : the link contained in the mail will expire in 1 hour.
            </p>
          </div>
        )}
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ForgottenPassword);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ForgottenPassword/index.tsx